/** Page size for events list (used by Events page server fetch and EventsProvider client logic). */
export const EVENTS_PER_PAGE = 12
